export interface QuillObjectDisplay {
    titre: string,
    texte: string,
    objectId: string,
    typeObject: QuillObjectTypeEnum,
    date?: Date
}

export enum QuillObjectTypeEnum {
    PATIENT_TEXTE = "patient_texte",
    PATIENT_MAQUETTE = "patient_maquette",
    PATIENT_CONSULTATION = "patient_consultation",
    PATIENT_CONSULTATIONS = "patient_consultations",
    PATIENT_ETAT_CIVIL = "patient_etat_civil",
    AGENDA_JOUR = "agenda_jour",
    PATIENT_VACCINS = "patient_vaccins",
    PATIENT_ANTECEDENTS = "patient_antecedents",
    PATIENT_ALARMES = "patient_alarmes",
    MEDECIN_ALARMES = "medecin_alarmes",
    PATIENT_DESENSIBILISATIONS = "patient_desensibilisations",
    PATIENT_ORDONNANCES = "patient_ordonnances",
    PATIENT_PRISE_EN_COURS = "patient_prise_en_cours"
}